import React from "react";

const GooglePlayIcon = ({ onClick }) => {
  return (
    <svg
      width="26"
      height="29"
      viewBox="0 0 26 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g clip-path="url(#clip0_2907_65)">
        <path
          d="M12.1419 13.8253L0.107422 26.5469C0.242568 27.0301 0.485429 27.4758 0.81744 27.8498C1.14945 28.2238 1.56182 28.5163 2.02303 28.7049C2.48424 28.8934 2.98208 28.9731 3.47848 28.9378C3.97489 28.9025 4.45673 28.7531 4.88716 28.5012L18.4282 20.7199L12.1419 13.8253Z"
          fill="#EA4335"
        />
        <path
          d="M24.311 11.6629L18.4555 8.27881L11.8643 14.1147L18.4823 20.7017L24.2933 17.3539C24.8081 17.0819 25.2392 16.6729 25.5401 16.1713C25.841 15.6697 26 15.0946 26 14.5083C26 13.922 25.841 13.3469 25.5401 12.8453C25.2392 12.3437 24.8081 11.9348 24.2933 11.6628L24.311 11.6629Z"
          fill="#FBBC04"
        />
        <path
          d="M0.107688 2.40674C0.0349885 2.67808 -0.00122125 2.95805 3.14198e-05 3.23913V25.7143C0.000749272 25.9953 0.0369256 26.2751 0.107688 26.5468L12.5547 14.151L0.107688 2.40674Z"
          fill="#0A61F5"
        />
        <path
          d="M12.2315 14.4768L18.4551 8.27894L4.93205 0.461444C4.42325 0.160808 3.84457 0.00159097 3.25495 6.28473e-06C1.79173 -0.00286297 0.505344 0.976989 0.107422 2.39778L12.2315 14.4768Z"
          fill="#34A853"
        />
      </g>
      <defs>
        <clipPath id="clip0_2907_65">
          <rect width="26" height="29" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GooglePlayIcon;
